<mat-select #combobox [(ngModel)]="selected" (selectionChange)="salvarImpressora()">
  <mat-option><ngx-mat-select-search [formControl]="impressoraMultiFilter" (keydown)="$event.stopPropagation()"
    placeholderLabel="Buscar..." noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
  <mat-option *ngIf="!isRequired" value="Sem Etiqueta">Sem Etiqueta</mat-option>
  <mat-option *ngFor="let impressora of filteredImpressora | async" [value]="impressora" [matTooltip]="impressora">
    {{ impressora }}
  </mat-option>
</mat-select>
